module.exports = __webpack_public_path__ + "redux.1iBnE9O8.png";